import { render, staticRenderFns } from "./SnippetNetwork.vue?vue&type=template&id=d4b3575e"
import script from "./SnippetNetwork.vue?vue&type=script&lang=js"
export * from "./SnippetNetwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4b3575e')) {
      api.createRecord('d4b3575e', component.options)
    } else {
      api.reload('d4b3575e', component.options)
    }
    module.hot.accept("./SnippetNetwork.vue?vue&type=template&id=d4b3575e", function () {
      api.rerender('d4b3575e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/SnippetNetwork.vue"
export default component.exports